import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, { encodeValuesOnly: true });

// Get Work Order List with Query (for remote ODataGrid)
export const getWorkOrderListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WORK_ORDERS}?${stringifyParams(params)}`
	);
};

// Get Work Order List (simple full list)
export const getWorkOrderList = params => {
	const queryParams = {
		filters: { disable: { $eq: false } },
		pagination: { page: 1, pageSize: 1000 },
		sort: ['creation_date:desc'],
		...params,
	};
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WORK_ORDERS}?${stringifyParams(queryParams)}`
	);
};

// Get Single Work Order
export const getWorkOrderApi = work_order_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WORK_ORDER}${work_order_id}`
	);
};

// Add New Work Order
export const addNewWorkOrderApi = work_order => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_WORK_ORDER}`,
		work_order
	);
};

// Update Work Order
export const updateWorkOrderApi = work_order => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_WORK_ORDER}${work_order._id}`,
		work_order
	);
};

// Delete Work Order
export const deleteWorkOrderApi = work_order_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_WORK_ORDER}${work_order_id}`
	);
};

// Get file download metadata for a Work Order
export const downloadWorkOrderFileApi = work_order_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.DOWNLOAD_WORK_ORDER}${work_order_id}`
	);
};
